// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom properties */
:root {
  --tooltip-text-color: #ffffff;
  --tooltip-background-color: #4a4747;
  ;
  --tooltip-margin: 30px;
  --tooltip-arrow-size: 6px;
  background: #fafafa !important;
}

/* Wrapping */
.Tooltip-Wrapper {
  display: inline-block;
  position: relative;
}

/* Absolute positioning */
.Tooltip-Tip {
  position: absolute;
  border-radius: 4px;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px;
  color: var(--tooltip-text-color);
  background: var(--tooltip-background-color);
  font-size: 10px;
  font-family: sans-serif;
  line-height: 1;
  z-index: 100;
  white-space: nowrap;
}

/* CSS border triangles */
.Tooltip-Tip::before {
  content: " ";
  left: 50%;
  border: solid transparent;
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-width: var(--tooltip-arrow-size);
  margin-left: calc(var(--tooltip-arrow-size) * -1);
}

/* Absolute positioning */
.Tooltip-Tip.top {
  top: calc(var(--tooltip-margin) * -1);
}

/* CSS border triangles */
.Tooltip-Tip.top::before {
  top: 100%;
  border-top-color: var(--tooltip-background-color);
}

/* Absolute positioning */
.Tooltip-Tip.right {
  left: calc(100% + var(--tooltip-margin));
  top: 50%;
  transform: translateX(0) translateY(-50%);
}

/* CSS border triangles */
.Tooltip-Tip.right::before {
  left: calc(var(--tooltip-arrow-size) * -1);
  top: 50%;
  transform: translateX(0) translateY(-50%);
  border-right-color: var(--tooltip-background-color);
}

/* Absolute positioning */
.Tooltip-Tip.bottom {
  bottom: calc(var(--tooltip-margin) * -1);
}

/* CSS border triangles */
.Tooltip-Tip.bottom::before {
  bottom: 100%;
  border-bottom-color: var(--tooltip-background-color);
}

/* Absolute positioning */
.Tooltip-Tip.left {
  left: auto;
  right: calc(100% + var(--tooltip-margin));
  top: 50%;
  transform: translateX(0) translateY(-50%);
}

/* CSS border triangles */
.Tooltip-Tip.left::before {
  left: auto;
  right: calc(var(--tooltip-arrow-size) * -2);
  top: 50%;
  transform: translateX(0) translateY(-50%);
  border-left-color: var(--tooltip-background-color);
}

.tooltip_p {
  font-size: 10px !important;
  text-wrap: pretty !important;
  width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/common/ToolTip/Tooltip.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,mCAAmC;;EAEnC,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,gCAAgC;EAChC,2CAA2C;EAC3C,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA,yBAAyB;AACzB;EACE,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;EACE,SAAS;EACT,iDAAiD;AACnD;;AAEA,yBAAyB;AACzB;EACE,wCAAwC;EACxC,QAAQ;EACR,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,0CAA0C;EAC1C,QAAQ;EACR,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA,yBAAyB;AACzB;EACE,wCAAwC;AAC1C;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,oDAAoD;AACtD;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,yCAAyC;EACzC,QAAQ;EACR,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,2CAA2C;EAC3C,QAAQ;EACR,yCAAyC;EACzC,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;AACd","sourcesContent":["/* Custom properties */\r\n:root {\r\n  --tooltip-text-color: #ffffff;\r\n  --tooltip-background-color: #4a4747;\r\n  ;\r\n  --tooltip-margin: 30px;\r\n  --tooltip-arrow-size: 6px;\r\n  background: #fafafa !important;\r\n}\r\n\r\n/* Wrapping */\r\n.Tooltip-Wrapper {\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n/* Absolute positioning */\r\n.Tooltip-Tip {\r\n  position: absolute;\r\n  border-radius: 4px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 6px;\r\n  color: var(--tooltip-text-color);\r\n  background: var(--tooltip-background-color);\r\n  font-size: 10px;\r\n  font-family: sans-serif;\r\n  line-height: 1;\r\n  z-index: 100;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* CSS border triangles */\r\n.Tooltip-Tip::before {\r\n  content: \" \";\r\n  left: 50%;\r\n  border: solid transparent;\r\n  height: 0;\r\n  width: 0;\r\n  position: absolute;\r\n  pointer-events: none;\r\n  border-width: var(--tooltip-arrow-size);\r\n  margin-left: calc(var(--tooltip-arrow-size) * -1);\r\n}\r\n\r\n/* Absolute positioning */\r\n.Tooltip-Tip.top {\r\n  top: calc(var(--tooltip-margin) * -1);\r\n}\r\n\r\n/* CSS border triangles */\r\n.Tooltip-Tip.top::before {\r\n  top: 100%;\r\n  border-top-color: var(--tooltip-background-color);\r\n}\r\n\r\n/* Absolute positioning */\r\n.Tooltip-Tip.right {\r\n  left: calc(100% + var(--tooltip-margin));\r\n  top: 50%;\r\n  transform: translateX(0) translateY(-50%);\r\n}\r\n\r\n/* CSS border triangles */\r\n.Tooltip-Tip.right::before {\r\n  left: calc(var(--tooltip-arrow-size) * -1);\r\n  top: 50%;\r\n  transform: translateX(0) translateY(-50%);\r\n  border-right-color: var(--tooltip-background-color);\r\n}\r\n\r\n/* Absolute positioning */\r\n.Tooltip-Tip.bottom {\r\n  bottom: calc(var(--tooltip-margin) * -1);\r\n}\r\n\r\n/* CSS border triangles */\r\n.Tooltip-Tip.bottom::before {\r\n  bottom: 100%;\r\n  border-bottom-color: var(--tooltip-background-color);\r\n}\r\n\r\n/* Absolute positioning */\r\n.Tooltip-Tip.left {\r\n  left: auto;\r\n  right: calc(100% + var(--tooltip-margin));\r\n  top: 50%;\r\n  transform: translateX(0) translateY(-50%);\r\n}\r\n\r\n/* CSS border triangles */\r\n.Tooltip-Tip.left::before {\r\n  left: auto;\r\n  right: calc(var(--tooltip-arrow-size) * -2);\r\n  top: 50%;\r\n  transform: translateX(0) translateY(-50%);\r\n  border-left-color: var(--tooltip-background-color);\r\n}\r\n\r\n.tooltip_p {\r\n  font-size: 10px !important;\r\n  text-wrap: pretty !important;\r\n  width: 300px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
